import React from "react"
import { PageHeader } from "@/components/ui/page-header"
import { EmptyState } from "@/components/ui/empty-state"
import { FileText } from "lucide-react"

export default function CarePlansPage() {
  return (
    <div className="mx-auto max-w-7xl space-y-6 p-4 md:p-8">
      <PageHeader
        title="Care Plans"
        description="Review and manage patient care plans"
      />

      <EmptyState
        icon={FileText}
        title="Care Plans Coming Soon"
        description="This feature is currently under development. Check back soon!"
      />
    </div>
  )
}
